// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AccessStripePortalData, AccessStripePortalErrors, AddExcludedDateData, AddExcludedDateErrors, AddExcludedDateResponses, ArchiveCourseData, ArchiveCourseErrors, ArchiveCourseResponses, BulkImportParentsData, BulkImportParentsErrors, BulkImportParentsResponses, CheckoutData, CheckoutResponses, CompleteRegistrationData, CompleteRegistrationErrors, CompleteRegistrationResponses, ConfirmDraftInvoicesData, ConfirmDraftInvoicesErrors, ConfirmDraftInvoicesResponses, ConfirmInvitationData, ConfirmInvitationErrors, ConfirmInvitationResponses, CreateAndSendSignupLinkData, CreateAndSendSignupLinkErrors, CreateAndSendSignupLinkResponses, CreateCourseData, CreateCourseErrors, CreateCourseResponses, CreateDebtForgivenessData, CreateDebtForgivenessErrors, CreateDebtForgivenessResponses, CreateInvitationData, CreateInvitationResponses, CreateManualPaymentData, CreateManualPaymentErrors, CreateManualPaymentResponses, CreateParentData, CreateParentErrors, CreateParentResponses, CreatePaymentSessionData, CreatePaymentSessionErrors, CreatePaymentSessionResponses, CreateSetupSessionData, CreateSetupSessionErrors, CreateSetupSessionResponses, CreateStudentData, CreateStudentErrors, CreateStudentResponses, CreateTeacherData, CreateTeacherErrors, CreateTeacherResponses, DeleteAttendanceData, DeleteAttendanceErrors, DeleteAttendanceResponses, DeleteCourseData, DeleteCourseErrors, DeleteCourseResponses, DeleteDraftInvoicesData, DeleteDraftInvoicesErrors, DeleteDraftInvoicesResponses, DeleteInvitationData, DeleteInvitationResponses, DeleteParentData, DeleteParentErrors, DeleteParentResponses, DeletePaymentMethodData, DeletePaymentMethodErrors, DeletePaymentMethodResponses, DeleteStudentData, DeleteStudentErrors, DeleteStudentResponses, DeleteTeacherData, DeleteTeacherErrors, DeleteTeacherResponses, DeleteUserData, DeleteUserResponses, DownloadInvoicePdfData, DownloadInvoicePdfErrors, DownloadInvoicePdfResponses, EnrollStudentData, EnrollStudentErrors, EnrollStudentResponses, EstimateSmsData, EstimateSmsErrors, EstimateSmsResponses, ExecuteCronTaskData, ExecuteCronTaskErrors, ExecuteCronTaskResponses, ExportAttendanceExcelData, ExportAttendanceExcelErrors, ExportAttendanceExcelResponses, FilterParentsData, FilterParentsErrors, FilterParentsResponses, ForgotPasswordData, ForgotPasswordResponses, GenerateMonthlyInvoiceData, GenerateMonthlyInvoiceErrors, GenerateMonthlyInvoiceResponses, GenerateMonthlyInvoicesForAllParentsData, GenerateMonthlyInvoicesForAllParentsDraftData, GenerateMonthlyInvoicesForAllParentsDraftErrors, GenerateMonthlyInvoicesForAllParentsDraftResponses, GenerateMonthlyInvoicesForAllParentsErrors, GenerateMonthlyInvoicesForAllParentsResponses, GetAllCoursesData, GetAllCoursesResponses, GetAllCronTasksData, GetAllCronTasksErrors, GetAllCronTasksResponses, GetAllInvitationsData, GetAllInvitationsResponses, GetAllInvoicesData, GetAllInvoicesResponses, GetAllNotificationsData, GetAllNotificationsErrors, GetAllNotificationsResponses, GetAllParentsData, GetAllParentsResponses, GetAllPaymentsData, GetAllPaymentsResponses, GetAllStudentsData, GetAllStudentsResponses, GetAllTeachersData, GetAllTeachersResponses, GetAllUsersData, GetAllUsersResponses, GetAttendancesByCourseData, GetAttendancesByCourseErrors, GetAttendancesByCourseResponses, GetAttendancesByDateData, GetAttendancesByDateResponses, GetAttendancesBySchoolAndDateData, GetAttendancesBySchoolAndDateResponses, GetAttendancesByStudentData, GetAttendancesByStudentErrors, GetAttendancesByStudentResponses, GetCourseByIdData, GetCourseByIdErrors, GetCourseByIdResponses, GetDashboardData, GetDashboardErrors, GetDashboardResponses, GetDraftInvoicesData, GetDraftInvoicesResponses, GetFailedNotificationsData, GetFailedNotificationsErrors, GetFailedNotificationsResponses, GetInvoiceByIdData, GetInvoiceByIdErrors, GetInvoiceByIdResponses, GetInvoiceDetailData, GetInvoiceDetailErrors, GetInvoiceDetailResponses, GetInvoiceItemsData, GetInvoiceItemsErrors, GetInvoiceItemsResponses, GetInvoices1Data, GetInvoices1Errors, GetInvoices1Responses, GetInvoicesByParentData, GetInvoicesByParentErrors, GetInvoicesByParentResponses, GetInvoicesData, GetInvoicesErrors, GetInvoicesResponses, GetLevelsData, GetLevelsResponses, GetMeData, GetMeErrors, GetMeResponses, GetNewEnrollmentsData, GetNewEnrollmentsResponses, GetParentByIdData, GetParentByIdErrors, GetParentByIdResponses, GetPaymentByIdData, GetPaymentByIdErrors, GetPaymentByIdResponses, GetPaymentDetailData, GetPaymentDetailErrors, GetPaymentDetailResponses, GetPaymentMethodsData, GetPaymentMethodsErrors, GetPaymentMethodsResponses, GetPaymentsData, GetPaymentsErrors, GetPaymentsResponses, GetPaymentStatusData, GetPaymentStatusErrors, GetPaymentStatusResponses, GetProfileData, GetProfileErrors, GetProfileResponses, GetSchoolsData, GetSchoolsResponses, GetSignupLinkDataData, GetSignupLinkDataErrors, GetSignupLinkDataResponses, GetStripePaymentMethodsData, GetStripePaymentMethodsErrors, GetStripePaymentMethodsResponses, GetStripePortalSessionData, GetStripePortalSessionErrors, GetStripePortalSessionResponses, GetStudentByIdData, GetStudentByIdErrors, GetStudentByIdResponses, GetStudentsByParentData, GetStudentsByParentResponses, GetSubjectsData, GetSubjectsResponses, GetTeacherByIdData, GetTeacherByIdErrors, GetTeacherByIdResponses, GetTimeSlotsData, GetTimeSlotsResponses, ImportAttendanceExcelData, ImportAttendanceExcelErrors, ImportAttendanceExcelResponses, LoginData, LoginResponses, MoveStudentData, MoveStudentErrors, MoveStudentResponses, PreparePaymentData, PreparePaymentErrors, PreparePaymentResponses, PreviewPaymentData, PreviewPaymentErrors, PreviewPaymentResponses, ProcessAutomaticPaymentData, ProcessAutomaticPaymentErrors, ProcessAutomaticPaymentResponses, ProcessManualPaymentData, ProcessManualPaymentErrors, ProcessManualPaymentResponses, RecordAttendanceData, RecordAttendanceErrors, RecordAttendanceResponses, RefundPaymentData, RefundPaymentErrors, RefundPaymentResponses, Register1Data, Register1Responses, RegisterData, RegisterErrors, RegisterResponses, RegisterStep1Data, RegisterStep1Errors, RegisterStep1Responses, RemoveExcludedDateData, RemoveExcludedDateErrors, RemoveExcludedDateResponses, ResendInvoiceData, ResendInvoiceErrors, ResendInvoiceResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, RetryAllFailedNotificationsData, RetryAllFailedNotificationsErrors, RetryAllFailedNotificationsResponses, RetryNotificationData, RetryNotificationErrors, RetryNotificationResponses, SaveBulkAttendancesData, SaveBulkAttendancesErrors, SaveBulkAttendancesResponses, SendBulkSmsData, SendBulkSmsErrors, SendBulkSmsResponses, SendOtpData, SendOtpResponses, SendPasswordResetEmailData, SendPasswordResetEmailResponses, SendPaymentLinkData, SendPaymentLinkErrors, SendPaymentLinkResponses, SendPaymentReminderData, SendPaymentReminderErrors, SendPaymentReminderResponses, SendSmsData, SendSmsErrors, SendSmsResponses, SetExcludedDatesData, SetExcludedDatesErrors, SetExcludedDatesResponses, TogglePaymentHoldData, TogglePaymentHoldErrors, TogglePaymentHoldResponses, UnarchiveCourseData, UnarchiveCourseErrors, UnarchiveCourseResponses, UnenrollStudentData, UnenrollStudentErrors, UnenrollStudentResponses, CancelUnenrollStudentData, CancelUnenrollStudentErrors, CancelUnenrollStudentResponses, UpdateAttendanceData, UpdateAttendanceErrors, UpdateAttendanceResponses, UpdateCourseData, UpdateCourseErrors, UpdateCourseResponses, UpdateEnrollmentDateData, UpdateEnrollmentDateErrors, UpdateEnrollmentDateResponses, UpdateMeData, UpdateMeErrors, UpdateMeResponses, UpdateParentData, UpdateParentErrors, UpdateParentResponses, UpdatePaymentMethod1Data, UpdatePaymentMethod1Errors, UpdatePaymentMethod1Responses, UpdatePaymentMethodData, UpdatePaymentMethodErrors, UpdatePaymentMethodResponses, UpdateStudentData, UpdateStudentErrors, UpdateStudentResponses, UpdateTeacherData, UpdateTeacherErrors, UpdateTeacherResponses, UpdateUserRoleData, UpdateUserRoleResponses, ValidateInvitationData, ValidateInvitationErrors, ValidateInvitationResponses, ValidateResetTokenData, ValidateResetTokenResponses, VerifyOtpData, VerifyOtpResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Mettre à jour le moyen de paiement
 *
 * Permet à un parent de modifier son moyen de paiement et le token associé
 */
export const updatePaymentMethod = <ThrowOnError extends boolean = false>(options: Options<UpdatePaymentMethodData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdatePaymentMethodResponses, UpdatePaymentMethodErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/{id}/payment-method',
        ...options
    });
};

/**
 * Compléter l'inscription d'un parent
 *
 * Ajoute les informations de paiement, commentaires et enfants à un parent créé à l'étape 1
 */
export const completeRegistration = <ThrowOnError extends boolean = false>(options: Options<CompleteRegistrationData, ThrowOnError>) => {
    return (options.client ?? client).put<CompleteRegistrationResponses, CompleteRegistrationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/{id}/complete-registration',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Récupérer son profil
 *
 * Obtenir les informations du parent authentifié
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/me',
        ...options
    });
};

/**
 * Modifier son profil
 *
 * Permet au parent authentifié de modifier ses informations
 */
export const updateMe = <ThrowOnError extends boolean = false>(options: Options<UpdateMeData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateMeResponses, UpdateMeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/me',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Changer le rôle d'un utilisateur
 */
export const updateUserRole = <ThrowOnError extends boolean = false>(options: Options<UpdateUserRoleData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateUserRoleResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/users/{id}/role',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Supprimer un professeur
 *
 * Supprimer définitivement un professeur du système
 */
export const deleteTeacher = <ThrowOnError extends boolean = false>(options: Options<DeleteTeacherData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteTeacherResponses, DeleteTeacherErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/teachers/{id}',
        ...options
    });
};

/**
 * Récupérer un professeur par ID
 *
 * Obtenir les détails d'un professeur spécifique avec ses cours et élèves
 */
export const getTeacherById = <ThrowOnError extends boolean = false>(options: Options<GetTeacherByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetTeacherByIdResponses, GetTeacherByIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/teachers/{id}',
        ...options
    });
};

/**
 * Mettre à jour un professeur
 *
 * Modifier les informations d'un professeur existant
 */
export const updateTeacher = <ThrowOnError extends boolean = false>(options: Options<UpdateTeacherData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateTeacherResponses, UpdateTeacherErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/teachers/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Supprimer un élève
 *
 * Supprimer définitivement un élève du système
 */
export const deleteStudent = <ThrowOnError extends boolean = false>(options: Options<DeleteStudentData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteStudentResponses, DeleteStudentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/students/{id}',
        ...options
    });
};

/**
 * Récupérer un élève par ID
 *
 * Obtenir les détails complets d'un élève spécifique
 */
export const getStudentById = <ThrowOnError extends boolean = false>(options: Options<GetStudentByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetStudentByIdResponses, GetStudentByIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/students/{id}',
        ...options
    });
};

/**
 * Mettre à jour un élève
 *
 * Modifier les informations d'un élève existant
 */
export const updateStudent = <ThrowOnError extends boolean = false>(options: Options<UpdateStudentData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateStudentResponses, UpdateStudentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/students/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Supprimer un parent
 *
 * Supprimer définitivement un parent du système
 */
export const deleteParent = <ThrowOnError extends boolean = false>(options: Options<DeleteParentData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteParentResponses, DeleteParentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/parents/{id}',
        ...options
    });
};

/**
 * Récupérer un parent par ID
 *
 * Obtenir les informations détaillées d'un parent spécifique
 */
export const getParentById = <ThrowOnError extends boolean = false>(options: Options<GetParentByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetParentByIdResponses, GetParentByIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/parents/{id}',
        ...options
    });
};

/**
 * Mettre à jour un parent
 *
 * Modifier les informations d'un parent existant
 */
export const updateParent = <ThrowOnError extends boolean = false>(options: Options<UpdateParentData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateParentResponses, UpdateParentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/parents/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mettre à jour le moyen de paiement
 *
 * Modifier le moyen de paiement d'un parent et le token associé
 */
export const updatePaymentMethod1 = <ThrowOnError extends boolean = false>(options: Options<UpdatePaymentMethod1Data, ThrowOnError>) => {
    return (options.client ?? client).put<UpdatePaymentMethod1Responses, UpdatePaymentMethod1Errors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/parents/{id}/payment-method',
        ...options
    });
};

/**
 * Activer/désactiver le blocage de paiement
 *
 * Permet de suspendre ou réactiver les paiements automatiques pour un parent
 */
export const togglePaymentHold = <ThrowOnError extends boolean = false>(options: Options<TogglePaymentHoldData, ThrowOnError>) => {
    return (options.client ?? client).put<TogglePaymentHoldResponses, TogglePaymentHoldErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/parents/{id}/payment-hold',
        ...options
    });
};

/**
 * Supprimer un cours
 *
 * Supprimer définitivement un cours du système
 */
export const deleteCourse = <ThrowOnError extends boolean = false>(options: Options<DeleteCourseData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteCourseResponses, DeleteCourseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{id}',
        ...options
    });
};

/**
 * Récupérer un cours par ID
 *
 * Obtenir les détails complets d'un cours spécifique
 */
export const getCourseById = <ThrowOnError extends boolean = false>(options: Options<GetCourseByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetCourseByIdResponses, GetCourseByIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{id}',
        ...options
    });
};

/**
 * Mettre à jour un cours
 *
 * Modifier les informations d'un cours existant
 */
export const updateCourse = <ThrowOnError extends boolean = false>(options: Options<UpdateCourseData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateCourseResponses, UpdateCourseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Supprimer une date d'exclusion
 *
 * Supprimer une date où le cours n'avait pas eu lieu
 */
export const removeExcludedDate = <ThrowOnError extends boolean = false>(options: Options<RemoveExcludedDateData, ThrowOnError>) => {
    return (options.client ?? client).delete<RemoveExcludedDateResponses, RemoveExcludedDateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{courseId}/excluded-dates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Ajouter une date d'exclusion
 *
 * Ajouter une date où le cours n'a pas eu lieu
 */
export const addExcludedDate = <ThrowOnError extends boolean = false>(options: Options<AddExcludedDateData, ThrowOnError>) => {
    return (options.client ?? client).post<AddExcludedDateResponses, AddExcludedDateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{courseId}/excluded-dates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Définir toutes les dates d'exclusion
 *
 * Remplacer toutes les dates d'exclusion d'un cours
 */
export const setExcludedDates = <ThrowOnError extends boolean = false>(options: Options<SetExcludedDatesData, ThrowOnError>) => {
    return (options.client ?? client).put<SetExcludedDatesResponses, SetExcludedDatesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{courseId}/excluded-dates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Modifier la date d'inscription d'un élève
 *
 * Permet de modifier la date d'inscription d'un élève à un cours
 */
export const updateEnrollmentDate = <ThrowOnError extends boolean = false>(options: Options<UpdateEnrollmentDateData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateEnrollmentDateResponses, UpdateEnrollmentDateErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/enrollments/{enrollmentId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Supprimer une présence
 *
 * Supprimer définitivement un enregistrement de présence du système
 */
export const deleteAttendance = <ThrowOnError extends boolean = false>(options: Options<DeleteAttendanceData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteAttendanceResponses, DeleteAttendanceErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/attendances/{id}',
        ...options
    });
};

/**
 * Mettre à jour une présence
 *
 * Modifier le statut ou les notes d'une présence existante
 */
export const updateAttendance = <ThrowOnError extends boolean = false>(options: Options<UpdateAttendanceData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateAttendanceResponses, UpdateAttendanceErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/attendances/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Créer une session Stripe en mode SETUP
 *
 * Crée une session Stripe pour configurer le moyen de paiement sans effectuer de paiement
 */
export const createSetupSession = <ThrowOnError extends boolean = false>(options: Options<CreateSetupSessionData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateSetupSessionResponses, CreateSetupSessionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/stripe/create-setup-session/{parentId}',
        ...options
    });
};

/**
 * Étape 1 de l'inscription
 *
 * Crée le parent et le customer Stripe avec les informations de base
 */
export const registerStep1 = <ThrowOnError extends boolean = false>(options: Options<RegisterStep1Data, ThrowOnError>) => {
    return (options.client ?? client).post<RegisterStep1Responses, RegisterStep1Errors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/step1',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Inscription d'un nouveau parent
 *
 * Permet à un parent de s'inscrire avec ses informations et celles de ses enfants
 */
export const register = <ThrowOnError extends boolean = false>(options: Options<RegisterData, ThrowOnError>) => {
    return (options.client ?? client).post<RegisterResponses, RegisterErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const verifyOtp = <ThrowOnError extends boolean = false>(options: Options<VerifyOtpData, ThrowOnError>) => {
    return (options.client ?? client).post<VerifyOtpResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/auth/verify-otp',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const sendOtp = <ThrowOnError extends boolean = false>(options: Options<SendOtpData, ThrowOnError>) => {
    return (options.client ?? client).post<SendOtpResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/auth/send-otp',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Prévisualiser un paiement
 *
 * Obtenir la répartition prévisionnelle d'un paiement sur les factures en attente
 */
export const preparePayment = <ThrowOnError extends boolean = false>(options: Options<PreparePaymentData, ThrowOnError>) => {
    return (options.client ?? client).post<PreparePaymentResponses, PreparePaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parent-portal/{parentId}/prepare-payment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Créer une session de paiement HelloAsso
 *
 * Générer une URL de paiement HelloAsso pour régulariser des factures
 */
export const createPaymentSession = <ThrowOnError extends boolean = false>(options: Options<CreatePaymentSessionData, ThrowOnError>) => {
    return (options.client ?? client).post<CreatePaymentSessionResponses, CreatePaymentSessionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parent-portal/{parentId}/create-payment-session',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Confirmer une invitation et créer le compte
 *
 * Permet de confirmer une invitation en fournissant un token et un mot de passe pour créer le compte utilisateur
 */
export const confirmInvitation = <ThrowOnError extends boolean = false>(options: Options<ConfirmInvitationData, ThrowOnError>) => {
    return (options.client ?? client).post<ConfirmInvitationResponses, ConfirmInvitationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invitations/confirm',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Exécuter une tâche cron avec une date simulée
 *
 * Permet d'exécuter manuellement une tâche cron avec une date spécifique pour les tests ou l'administration
 */
export const executeCronTask = <ThrowOnError extends boolean = false>(options: Options<ExecuteCronTaskData, ThrowOnError>) => {
    return (options.client ?? client).post<ExecuteCronTaskResponses, ExecuteCronTaskErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/cron-tasks/execute',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Réinitialiser le mot de passe avec un token
 *
 * Permet de définir un nouveau mot de passe en utilisant un token de réinitialisation valide
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth/reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const register1 = <ThrowOnError extends boolean = false>(options: Options<Register1Data, ThrowOnError>) => {
    return (options.client ?? client).post<Register1Responses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => {
    return (options.client ?? client).post<LoginResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Demander une réinitialisation de mot de passe
 *
 * Envoie un email avec un lien de réinitialisation si l'adresse email existe dans le système
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<ForgotPasswordResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth/forgot-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Envoyer un email de réinitialisation de mot de passe
 */
export const sendPasswordResetEmail = <ThrowOnError extends boolean = false>(options: Options<SendPasswordResetEmailData, ThrowOnError>) => {
    return (options.client ?? client).post<SendPasswordResetEmailResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/users/{id}/reset-password',
        ...options
    });
};

/**
 * Récupérer tous les professeurs
 *
 * Obtenir la liste complète de tous les professeurs
 */
export const getAllTeachers = <ThrowOnError extends boolean = false>(options?: Options<GetAllTeachersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllTeachersResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/teachers',
        ...options
    });
};

/**
 * Créer un nouveau professeur
 *
 * Permet de créer un nouveau professeur dans le système
 */
export const createTeacher = <ThrowOnError extends boolean = false>(options: Options<CreateTeacherData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateTeacherResponses, CreateTeacherErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/teachers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Récupérer tous les élèves
 *
 * Obtenir la liste de tous les élèves du système
 */
export const getAllStudents = <ThrowOnError extends boolean = false>(options?: Options<GetAllStudentsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllStudentsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/students',
        ...options
    });
};

/**
 * Créer un nouvel élève
 *
 * Permet de créer un nouvel élève dans le système
 */
export const createStudent = <ThrowOnError extends boolean = false>(options: Options<CreateStudentData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateStudentResponses, CreateStudentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/students',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Envoyer des SMS groupés
 *
 * Envoyer des SMS à plusieurs parents en une seule opération (asynchrone)
 */
export const sendBulkSms = <ThrowOnError extends boolean = false>(options: Options<SendBulkSmsData, ThrowOnError>) => {
    return (options.client ?? client).post<SendBulkSmsResponses, SendBulkSmsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/sms/send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Filtrer les parents
 *
 * Filtrer les parents selon différents critères (cours, école, date, statut paiement)
 */
export const filterParents = <ThrowOnError extends boolean = false>(options: Options<FilterParentsData, ThrowOnError>) => {
    return (options.client ?? client).post<FilterParentsResponses, FilterParentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/sms/filter-parents',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Estimer le coût d'envoi de SMS
 *
 * Calculer le coût estimé pour l'envoi de SMS groupés avant l'envoi réel
 */
export const estimateSms = <ThrowOnError extends boolean = false>(options: Options<EstimateSmsData, ThrowOnError>) => {
    return (options.client ?? client).post<EstimateSmsResponses, EstimateSmsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/sms/estimate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Créer un lien d'inscription et l'envoyer par SMS
 *
 * Génère un lien d'inscription pré-rempli avec les informations de l'élève et l'envoie par SMS au parent
 */
export const createAndSendSignupLink = <ThrowOnError extends boolean = false>(options: Options<CreateAndSendSignupLinkData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateAndSendSignupLinkResponses, CreateAndSendSignupLinkErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/signup-links/send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Rembourser un paiement
 *
 * Effectuer un remboursement total ou partiel d'un paiement
 */
export const refundPayment = <ThrowOnError extends boolean = false>(options: Options<RefundPaymentData, ThrowOnError>) => {
    return (options.client ?? client).post<RefundPaymentResponses, RefundPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/payments/{paymentId}/refund',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Prévisualiser un paiement
 *
 * Obtenir la répartition prévisionnelle d'un paiement sur les factures
 */
export const previewPayment = <ThrowOnError extends boolean = false>(options: Options<PreviewPaymentData, ThrowOnError>) => {
    return (options.client ?? client).post<PreviewPaymentResponses, PreviewPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/payments/preview',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Traiter un paiement manuel
 *
 * Enregistrer un paiement effectué manuellement (chèque, espèces, virement)
 */
export const processManualPayment = <ThrowOnError extends boolean = false>(options: Options<ProcessManualPaymentData, ThrowOnError>) => {
    return (options.client ?? client).post<ProcessManualPaymentResponses, ProcessManualPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/payments/manual',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Créer un paiement manuel multi-factures
 *
 * Enregistrer un paiement manuel pouvant être réparti sur plusieurs factures
 */
export const createManualPayment = <ThrowOnError extends boolean = false>(options: Options<CreateManualPaymentData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateManualPaymentResponses, CreateManualPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/payments/manual-multi',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Effacer une dette (debt forgiveness)
 *
 * Annuler une dette d'un parent (remise gracieuse)
 */
export const createDebtForgiveness = <ThrowOnError extends boolean = false>(options: Options<CreateDebtForgivenessData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateDebtForgivenessResponses, CreateDebtForgivenessErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/payments/debt-forgiveness',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Déclencher un paiement automatique
 *
 * Initier un prélèvement automatique pour une facture
 */
export const processAutomaticPayment = <ThrowOnError extends boolean = false>(options: Options<ProcessAutomaticPaymentData, ThrowOnError>) => {
    return (options.client ?? client).post<ProcessAutomaticPaymentResponses, ProcessAutomaticPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/payments/automatic/{invoiceId}',
        ...options
    });
};

/**
 * Récupérer tous les parents
 *
 * Obtenir la liste complète de tous les parents enregistrés dans le système avec leurs enfants
 */
export const getAllParents = <ThrowOnError extends boolean = false>(options?: Options<GetAllParentsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllParentsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/parents',
        ...options
    });
};

/**
 * Créer un nouveau parent
 *
 * Permet à un administrateur de créer un nouveau parent dans le système
 */
export const createParent = <ThrowOnError extends boolean = false>(options: Options<CreateParentData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateParentResponses, CreateParentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/parents',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Envoyer un SMS manuel à un parent
 *
 * Permet d'envoyer un SMS personnalisé à un parent
 */
export const sendSms = <ThrowOnError extends boolean = false>(options: Options<SendSmsData, ThrowOnError>) => {
    return (options.client ?? client).post<SendSmsResponses, SendSmsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/parents/{id}/send-sms',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Import en masse de parents
 *
 * Permet d'importer plusieurs parents avec leurs enfants en une seule requête
 */
export const bulkImportParents = <ThrowOnError extends boolean = false>(options: Options<BulkImportParentsData, ThrowOnError>) => {
    return (options.client ?? client).post<BulkImportParentsResponses, BulkImportParentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/parents/bulk-import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Relancer une notification échouée
 *
 * Relancer l'envoi d'une notification spécifique qui a échoué
 */
export const retryNotification = <ThrowOnError extends boolean = false>(options: Options<RetryNotificationData, ThrowOnError>) => {
    return (options.client ?? client).post<RetryNotificationResponses, RetryNotificationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/notifications/{notificationId}/retry',
        ...options
    });
};

/**
 * Relancer toutes les notifications échouées
 *
 * Relancer l'envoi de toutes les notifications qui ont échoué
 */
export const retryAllFailedNotifications = <ThrowOnError extends boolean = false>(options?: Options<RetryAllFailedNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).post<RetryAllFailedNotificationsResponses, RetryAllFailedNotificationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/notifications/retry-all-failed',
        ...options
    });
};

/**
 * Envoyer un rappel de paiement
 *
 * Envoyer un email de rappel au parent concernant une facture impayée
 */
export const sendPaymentReminder = <ThrowOnError extends boolean = false>(options: Options<SendPaymentReminderData, ThrowOnError>) => {
    return (options.client ?? client).post<SendPaymentReminderResponses, SendPaymentReminderErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/{id}/send-reminder',
        ...options
    });
};

/**
 * Envoyer le lien de paiement
 *
 * Envoyer par email le lien de paiement pour une facture au parent concerné
 */
export const sendPaymentLink = <ThrowOnError extends boolean = false>(options: Options<SendPaymentLinkData, ThrowOnError>) => {
    return (options.client ?? client).post<SendPaymentLinkResponses, SendPaymentLinkErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/{id}/send-payment-link',
        ...options
    });
};

/**
 * Renvoyer l'email de facture
 *
 * Renvoyer l'email de facture original au parent concerné
 */
export const resendInvoice = <ThrowOnError extends boolean = false>(options: Options<ResendInvoiceData, ThrowOnError>) => {
    return (options.client ?? client).post<ResendInvoiceResponses, ResendInvoiceErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/{id}/resend-invoice',
        ...options
    });
};

/**
 * Générer une facture mensuelle
 *
 * Créer une nouvelle facture mensuelle pour un parent pour la période spécifiée
 */
export const generateMonthlyInvoice = <ThrowOnError extends boolean = false>(options: Options<GenerateMonthlyInvoiceData, ThrowOnError>) => {
    return (options.client ?? client).post<GenerateMonthlyInvoiceResponses, GenerateMonthlyInvoiceErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/generate/{parentId}',
        ...options
    });
};

/**
 * Générer les factures mensuelles pour tous les parents
 *
 * Créer les factures mensuelles pour tous les parents ayant des présences enregistrées pour la période spécifiée
 */
export const generateMonthlyInvoicesForAllParents = <ThrowOnError extends boolean = false>(options: Options<GenerateMonthlyInvoicesForAllParentsData, ThrowOnError>) => {
    return (options.client ?? client).post<GenerateMonthlyInvoicesForAllParentsResponses, GenerateMonthlyInvoicesForAllParentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/generate-monthly',
        ...options
    });
};

/**
 * Générer les factures mensuelles en mode brouillon
 *
 * Créer les factures mensuelles en mode DRAFT pour preview avant confirmation
 */
export const generateMonthlyInvoicesForAllParentsDraft = <ThrowOnError extends boolean = false>(options: Options<GenerateMonthlyInvoicesForAllParentsDraftData, ThrowOnError>) => {
    return (options.client ?? client).post<GenerateMonthlyInvoicesForAllParentsDraftResponses, GenerateMonthlyInvoicesForAllParentsDraftErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/generate-monthly-draft',
        ...options
    });
};

/**
 * Confirmer les factures brouillon
 *
 * Confirmer toutes les factures DRAFT d'une période (passer en PENDING et envoyer les notifications)
 */
export const confirmDraftInvoices = <ThrowOnError extends boolean = false>(options: Options<ConfirmDraftInvoicesData, ThrowOnError>) => {
    return (options.client ?? client).post<ConfirmDraftInvoicesResponses, ConfirmDraftInvoicesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/confirm-draft',
        ...options
    });
};

/**
 * Lister toutes les invitations
 */
export const getAllInvitations = <ThrowOnError extends boolean = false>(options?: Options<GetAllInvitationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllInvitationsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invitations',
        ...options
    });
};

/**
 * Créer une invitation
 */
export const createInvitation = <ThrowOnError extends boolean = false>(options: Options<CreateInvitationData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateInvitationResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invitations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Récupérer tous les cours
 *
 * Obtenir la liste complète de tous les cours enregistrés dans le système
 */
export const getAllCourses = <ThrowOnError extends boolean = false>(options?: Options<GetAllCoursesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllCoursesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses',
        ...options
    });
};

/**
 * Créer un nouveau cours
 *
 * Permet de créer un nouveau cours dans le système avec toutes ses caractéristiques
 */
export const createCourse = <ThrowOnError extends boolean = false>(options: Options<CreateCourseData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateCourseResponses, CreateCourseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Changer un élève de cours
 *
 * Déplacer un élève d'un cours à un autre
 */
export const moveStudent = <ThrowOnError extends boolean = false>(options: Options<MoveStudentData, ThrowOnError>) => {
    return (options.client ?? client).post<MoveStudentResponses, MoveStudentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{fromCourseId}/students/{studentId}/move/{toCourseId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Désinscrire un élève d'un cours
 *
 * Retirer un élève d'un cours existant
 */
export const unenrollStudent = <ThrowOnError extends boolean = false>(options: Options<UnenrollStudentData, ThrowOnError>) => {
    return (options.client ?? client).delete<UnenrollStudentResponses, UnenrollStudentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{courseId}/students/{studentId}',
        ...options
    });
};

/**
 * Archiver un cours
 *
 * Clôturer un cours en fin d'année : le cours devient en lecture seule, ses présences sont conservées et toutes les inscriptions encore actives sont terminées à la date d'archivage
 */
export const archiveCourse = <ThrowOnError extends boolean = false>(options: Options<ArchiveCourseData, ThrowOnError>) => {
    return (options.client ?? client).post<ArchiveCourseResponses, ArchiveCourseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{id}/archive',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Désarchiver un cours
 *
 * Réactiver un cours archivé. Les inscriptions clôturées lors de l'archivage ne sont pas rouvertes
 */
export const unarchiveCourse = <ThrowOnError extends boolean = false>(options: Options<UnarchiveCourseData, ThrowOnError>) => {
    return (options.client ?? client).post<UnarchiveCourseResponses, UnarchiveCourseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{id}/unarchive',
        ...options
    });
};

/**
 * Annuler la désinscription planifiée d'un élève
 *
 * Annuler une désinscription future d'un élève d'un cours
 */
export const cancelUnenrollStudent = <ThrowOnError extends boolean = false>(options: Options<CancelUnenrollStudentData, ThrowOnError>) => {
    return (options.client ?? client).post<CancelUnenrollStudentResponses, CancelUnenrollStudentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{courseId}/students/{studentId}/cancel-unenroll',
        ...options
    });
};

/**
 * Inscrire un élève à un cours
 *
 * Ajouter un élève à un cours existant
 */
export const enrollStudent = <ThrowOnError extends boolean = false>(options: Options<EnrollStudentData, ThrowOnError>) => {
    return (options.client ?? client).post<EnrollStudentResponses, EnrollStudentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/courses/{courseId}/students/{studentId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Enregistrer une présence
 *
 * Créer un nouvel enregistrement de présence pour un élève dans un cours
 */
export const recordAttendance = <ThrowOnError extends boolean = false>(options: Options<RecordAttendanceData, ThrowOnError>) => {
    return (options.client ?? client).post<RecordAttendanceResponses, RecordAttendanceErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/attendances',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Importer un fichier Excel de présences
 *
 * Parse un fichier Excel et retourne les données de présences pour sauvegarde
 */
export const importAttendanceExcel = <ThrowOnError extends boolean = false>(options: Options<ImportAttendanceExcelData, ThrowOnError>) => {
    return (options.client ?? client).post<ImportAttendanceExcelResponses, ImportAttendanceExcelErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/attendances/import-excel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Enregistrer des présences en masse
 *
 * Créer ou mettre à jour plusieurs enregistrements de présence en une seule opération
 */
export const saveBulkAttendances = <ThrowOnError extends boolean = false>(options: Options<SaveBulkAttendancesData, ThrowOnError>) => {
    return (options.client ?? client).post<SaveBulkAttendancesResponses, SaveBulkAttendancesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/attendances/bulk',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Récupérer les données d'un lien d'inscription
 *
 * Retourne les informations pré-remplies associées à un token de lien d'inscription
 */
export const getSignupLinkData = <ThrowOnError extends boolean = false>(options: Options<GetSignupLinkDataData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSignupLinkDataResponses, GetSignupLinkDataErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/signup-links/{token}',
        ...options
    });
};

/**
 * Télécharger une facture en PDF
 *
 * Génère et télécharge la facture au format PDF
 */
export const downloadInvoicePdf = <ThrowOnError extends boolean = false>(options: Options<DownloadInvoicePdfData, ThrowOnError>) => {
    return (options.client ?? client).get<DownloadInvoicePdfResponses, DownloadInvoicePdfErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/public/invoices/{id}/pdf',
        ...options
    });
};

/**
 * Récupérer le profil d'un parent
 *
 * Obtenir les informations détaillées d'un parent par son ID
 */
export const getProfile = <ThrowOnError extends boolean = false>(options: Options<GetProfileData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProfileResponses, GetProfileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/{id}',
        ...options
    });
};

/**
 * Récupérer les moyens de paiement
 *
 * Obtenir la liste des moyens de paiement Stripe associés à un parent
 */
export const getPaymentMethods = <ThrowOnError extends boolean = false>(options: Options<GetPaymentMethodsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPaymentMethodsResponses, GetPaymentMethodsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/{id}/payment-methods',
        ...options
    });
};

/**
 * Récupérer les factures d'un parent
 *
 * Obtenir la liste de toutes les factures associées à un parent
 */
export const getInvoices = <ThrowOnError extends boolean = false>(options: Options<GetInvoicesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetInvoicesResponses, GetInvoicesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/{id}/invoices',
        ...options
    });
};

/**
 * Obtenir l'URL du portail Stripe
 *
 * Générer une URL vers le portail de gestion des moyens de paiement Stripe
 */
export const getStripePortalSession = <ThrowOnError extends boolean = false>(options: Options<GetStripePortalSessionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetStripePortalSessionResponses, GetStripePortalSessionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parent-portal/{parentId}/stripe/portal-session',
        ...options
    });
};

/**
 * Récupérer tous les paiements du parent
 *
 * Obtenir l'historique complet des paiements (triés par date de création décroissante)
 */
export const getPayments = <ThrowOnError extends boolean = false>(options: Options<GetPaymentsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPaymentsResponses, GetPaymentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parent-portal/{parentId}/payments',
        ...options
    });
};

/**
 * Récupérer le détail d'un paiement
 *
 * Obtenir les détails complets d'un paiement avec sa répartition sur les factures
 */
export const getPaymentDetail = <ThrowOnError extends boolean = false>(options: Options<GetPaymentDetailData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPaymentDetailResponses, GetPaymentDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parent-portal/{parentId}/payments/{paymentId}',
        ...options
    });
};

/**
 * Vérifier le statut d'un paiement HelloAsso
 *
 * Récupérer le statut actuel d'un paiement HelloAsso pour le polling
 */
export const getPaymentStatus = <ThrowOnError extends boolean = false>(options: Options<GetPaymentStatusData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPaymentStatusResponses, GetPaymentStatusErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parent-portal/{parentId}/payment/{paymentId}/status',
        ...options
    });
};

/**
 * Récupérer toutes les factures du parent
 *
 * Obtenir la liste complète des factures (triées par date de création décroissante)
 */
export const getInvoices1 = <ThrowOnError extends boolean = false>(options: Options<GetInvoices1Data, ThrowOnError>) => {
    return (options.client ?? client).get<GetInvoices1Responses, GetInvoices1Errors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parent-portal/{parentId}/invoices',
        ...options
    });
};

/**
 * Récupérer le détail d'une facture
 *
 * Obtenir les détails complets d'une facture avec ses allocations de paiement
 */
export const getInvoiceDetail = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceDetailData, ThrowOnError>) => {
    return (options.client ?? client).get<GetInvoiceDetailResponses, GetInvoiceDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parent-portal/{parentId}/invoices/{invoiceId}',
        ...options
    });
};

/**
 * Récupérer le tableau de bord parent
 *
 * Obtenir le solde, le nombre de factures à régulariser, les dernières factures et paiements
 */
export const getDashboard = <ThrowOnError extends boolean = false>(options: Options<GetDashboardData, ThrowOnError>) => {
    return (options.client ?? client).get<GetDashboardResponses, GetDashboardErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parent-portal/{parentId}/dashboard',
        ...options
    });
};

/**
 * Rediriger vers le portail Stripe (legacy)
 *
 * Point d'entrée historique - redirige vers le portail de gestion Stripe
 */
export const accessStripePortal = <ThrowOnError extends boolean = false>(options: Options<AccessStripePortalData, ThrowOnError>) => {
    return (options.client ?? client).get<unknown, AccessStripePortalErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parent-portal/{id}/portal',
        ...options
    });
};

/**
 * Valider un token d'invitation
 *
 * Vérifie la validité d'un token d'invitation et retourne les informations associées
 */
export const validateInvitation = <ThrowOnError extends boolean = false>(options: Options<ValidateInvitationData, ThrowOnError>) => {
    return (options.client ?? client).get<ValidateInvitationResponses, ValidateInvitationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/invitations/validate/{token}',
        ...options
    });
};

/**
 * Récupérer les créneaux disponibles
 *
 * Retourne la liste de tous les créneaux horaires disponibles
 */
export const getTimeSlots = <ThrowOnError extends boolean = false>(options?: Options<GetTimeSlotsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetTimeSlotsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/enums/time-slots',
        ...options
    });
};

/**
 * Récupérer les matières disponibles
 *
 * Retourne la liste de toutes les matières enseignées
 */
export const getSubjects = <ThrowOnError extends boolean = false>(options?: Options<GetSubjectsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSubjectsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/enums/subjects',
        ...options
    });
};

/**
 * Récupérer les établissements scolaires
 *
 * Retourne la liste des établissements scolaires référencés
 */
export const getSchools = <ThrowOnError extends boolean = false>(options?: Options<GetSchoolsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetSchoolsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/enums/schools',
        ...options
    });
};

/**
 * Récupérer les niveaux disponibles
 *
 * Retourne la liste de tous les niveaux scolaires
 */
export const getLevels = <ThrowOnError extends boolean = false>(options?: Options<GetLevelsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetLevelsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/enums/levels',
        ...options
    });
};

/**
 * Récupérer toutes les tâches cron disponibles
 *
 * Obtenir la liste complète des tâches cron configurées dans le système
 */
export const getAllCronTasks = <ThrowOnError extends boolean = false>(options?: Options<GetAllCronTasksData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllCronTasksResponses, GetAllCronTasksErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/cron-tasks',
        ...options
    });
};

/**
 * Valider un token de réinitialisation
 *
 * Vérifie si un token de réinitialisation de mot de passe est valide et non expiré
 */
export const validateResetToken = <ThrowOnError extends boolean = false>(options: Options<ValidateResetTokenData, ThrowOnError>) => {
    return (options.client ?? client).get<ValidateResetTokenResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth/validate-reset-token/{token}',
        ...options
    });
};

export const checkout = <ThrowOnError extends boolean = false>(options?: Options<CheckoutData, ThrowOnError>) => {
    return (options?.client ?? client).get<CheckoutResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/auth/checkout',
        ...options
    });
};

/**
 * Lister tous les utilisateurs
 */
export const getAllUsers = <ThrowOnError extends boolean = false>(options?: Options<GetAllUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllUsersResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/users',
        ...options
    });
};

/**
 * Récupérer les élèves d'un parent
 *
 * Obtenir la liste des élèves rattachés à un parent
 */
export const getStudentsByParent = <ThrowOnError extends boolean = false>(options: Options<GetStudentsByParentData, ThrowOnError>) => {
    return (options.client ?? client).get<GetStudentsByParentResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/students/by-parent/{parentId}',
        ...options
    });
};

/**
 * Récupérer tous les paiements
 *
 * Obtenir la liste de tous les paiements du système
 */
export const getAllPayments = <ThrowOnError extends boolean = false>(options?: Options<GetAllPaymentsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllPaymentsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/payments',
        ...options
    });
};

/**
 * Obtenir un paiement par ID
 *
 * Récupérer les détails d'un paiement
 */
export const getPaymentById = <ThrowOnError extends boolean = false>(options: Options<GetPaymentByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetPaymentByIdResponses, GetPaymentByIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/payments/{id}',
        ...options
    });
};

/**
 * Récupérer les moyens de paiement Stripe
 *
 * Obtenir la liste des moyens de paiement enregistrés sur Stripe pour un parent
 */
export const getStripePaymentMethods = <ThrowOnError extends boolean = false>(options: Options<GetStripePaymentMethodsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetStripePaymentMethodsResponses, GetStripePaymentMethodsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/parents/{id}/stripe-payment-methods',
        ...options
    });
};

/**
 * Récupérer les nouveaux inscrits
 *
 * Obtenir la liste des parents ayant complété l'inscription mais sans inscription à un cours
 */
export const getNewEnrollments = <ThrowOnError extends boolean = false>(options?: Options<GetNewEnrollmentsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetNewEnrollmentsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/parents/new-enrollments',
        ...options
    });
};

/**
 * Récupérer toutes les notifications
 *
 * Obtenir une liste paginée de toutes les notifications du système
 */
export const getAllNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetAllNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllNotificationsResponses, GetAllNotificationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/notifications',
        ...options
    });
};

/**
 * Récupérer les notifications échouées
 *
 * Obtenir la liste de toutes les notifications avec le statut FAILED
 */
export const getFailedNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetFailedNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetFailedNotificationsResponses, GetFailedNotificationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/notifications/failed',
        ...options
    });
};

/**
 * Récupérer toutes les factures
 *
 * Obtenir la liste de toutes les factures du système
 */
export const getAllInvoices = <ThrowOnError extends boolean = false>(options?: Options<GetAllInvoicesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAllInvoicesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices',
        ...options
    });
};

/**
 * Récupérer une facture par ID
 *
 * Obtenir les détails complets d'une facture spécifique
 */
export const getInvoiceById = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetInvoiceByIdResponses, GetInvoiceByIdErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/{id}',
        ...options
    });
};

/**
 * Récupérer les détails des cours d'une facture
 *
 * Obtenir la liste détaillée des cours facturés avec quantités et montants
 */
export const getInvoiceItems = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceItemsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetInvoiceItemsResponses, GetInvoiceItemsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/{id}/items',
        ...options
    });
};

/**
 * Récupérer les factures d'un parent
 *
 * Obtenir la liste de toutes les factures d'un parent spécifique
 */
export const getInvoicesByParent = <ThrowOnError extends boolean = false>(options: Options<GetInvoicesByParentData, ThrowOnError>) => {
    return (options.client ?? client).get<GetInvoicesByParentResponses, GetInvoicesByParentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/parent/{parentId}',
        ...options
    });
};

/**
 * Récupérer toutes les factures brouillon
 *
 * Obtenir la liste de toutes les factures en mode DRAFT
 */
export const getDraftInvoices = <ThrowOnError extends boolean = false>(options?: Options<GetDraftInvoicesData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetDraftInvoicesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/draft',
        ...options
    });
};

/**
 * Récupérer les présences d'un élève
 *
 * Obtenir la liste de toutes les présences d'un élève spécifique
 */
export const getAttendancesByStudent = <ThrowOnError extends boolean = false>(options: Options<GetAttendancesByStudentData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAttendancesByStudentResponses, GetAttendancesByStudentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/attendances/student/{studentId}',
        ...options
    });
};

/**
 * Télécharger le fichier Excel des présences
 *
 * Génère et télécharge un fichier Excel pré-rempli pour saisie des présences
 */
export const exportAttendanceExcel = <ThrowOnError extends boolean = false>(options: Options<ExportAttendanceExcelData, ThrowOnError>) => {
    return (options.client ?? client).get<ExportAttendanceExcelResponses, ExportAttendanceExcelErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/attendances/export-excel',
        ...options
    });
};

/**
 * Récupérer les présences par date
 *
 * Obtenir la liste de toutes les présences pour une date spécifique
 */
export const getAttendancesByDate = <ThrowOnError extends boolean = false>(options?: Options<GetAttendancesByDateData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAttendancesByDateResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/attendances/date/{date}',
        ...options
    });
};

/**
 * Récupérer les présences d'un cours
 *
 * Obtenir la liste de toutes les présences pour un cours spécifique
 */
export const getAttendancesByCourse = <ThrowOnError extends boolean = false>(options: Options<GetAttendancesByCourseData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAttendancesByCourseResponses, GetAttendancesByCourseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/attendances/course/{courseId}',
        ...options
    });
};

/**
 * Récupérer les présences par établissement et date
 *
 * Obtenir toutes les présences d'un établissement pour une date spécifique avec les créneaux horaires
 */
export const getAttendancesBySchoolAndDate = <ThrowOnError extends boolean = false>(options: Options<GetAttendancesBySchoolAndDateData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAttendancesBySchoolAndDateResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/attendances/by-school-and-date',
        ...options
    });
};

/**
 * Supprimer un moyen de paiement
 *
 * Supprimer un moyen de paiement Stripe
 */
export const deletePaymentMethod = <ThrowOnError extends boolean = false>(options: Options<DeletePaymentMethodData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeletePaymentMethodResponses, DeletePaymentMethodErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/parents/{id}/payment-methods/{paymentMethodId}',
        ...options
    });
};

/**
 * Supprimer un utilisateur
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteUserResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/users/{id}',
        ...options
    });
};

/**
 * Supprimer les factures brouillon
 *
 * Supprimer toutes les factures DRAFT d'une période
 */
export const deleteDraftInvoices = <ThrowOnError extends boolean = false>(options: Options<DeleteDraftInvoicesData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteDraftInvoicesResponses, DeleteDraftInvoicesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invoices/delete-draft',
        ...options
    });
};

/**
 * Supprimer une invitation
 */
export const deleteInvitation = <ThrowOnError extends boolean = false>(options: Options<DeleteInvitationData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteInvitationResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/admin/invitations/{id}',
        ...options
    });
};
